import {APIClient, getLang, JSONClient, ProjectJSONClient} from "modules/utils";
import {
	ISquad,
	IPrediction,
	IFanSentiments,
	IDrawPredictorSettings,
	IFanFact,
	IQualifierGroup,
	IQualifierSquad,
} from "apps/DRAW_PREDICTOR/modules/reducers";
import {IApiResponse, IDictionary} from "modules/types";

export interface IFetchPrediction {
	predictions: IPrediction[];
}

export interface IFetchPredictionLite extends IFetchPrediction {
	user_qualified: number[];
}

interface IFanSentimentsSavePayload {
	answers: IFanSentimentAnswer[];
}

export interface IFanSentimentAnswer {
	questionId: number;
	optionIds: number[];
}

export const DrawPredictorApi = {
	JSON: {
		squads: () => ProjectJSONClient.get<{squads: ISquad[]}>("squads.json"),
		supported_countries: () =>
			ProjectJSONClient.get<IDictionary<string>>("supported_countries.json"),
		fan_sentiment_questions: () =>
			ProjectJSONClient.get<IFanSentiments>("fan_sentiment_questions.json"),
		settings: () => ProjectJSONClient.get<IDrawPredictorSettings>("settings.json"),
		fan_facts: () => ProjectJSONClient.get<IDictionary<IFanFact>>(`facts/${getLang()}.json`),
		qualifierGroups: () =>
			JSONClient.get<{groups: IQualifierGroup[]; pre_state_enabled: boolean}>(
				"qualifier/groups.json"
			),
		qualifierSquads: () => JSONClient.get<IQualifierSquad[]>("qualifier/squads.json"),
	},
	predictions: {
		predictions: () =>
			APIClient.get<IApiResponse<IFetchPrediction>>(
				`${getLang()}/draw-predictor/predictions`
			),

		save_predictions: (params: IFetchPrediction) =>
			APIClient.post<IApiResponse<IFetchPrediction>>(
				`${getLang()}/draw-predictor/prediction/save-multiple`,
				params
			),
		api_prediction_simulate: (params: IFetchPrediction) =>
			APIClient.post<IApiResponse<IFetchPrediction>>(
				`${getLang()}/draw-predictor/prediction/simulate`,
				params
			),
		api_free_prediction_simulate: (params: IFetchPrediction) =>
			APIClient.post<IApiResponse<IFetchPrediction>>(
				`${getLang()}/draw-predictor/prediction/simulate-free`,
				params
			),
		api_prediction_simulate_lite: (params: IFetchPredictionLite) =>
			APIClient.post<IApiResponse<IFetchPrediction>>(
				`${getLang()}/qualifier/simulate`,
				params
			),
	},
	fan_sentiment: {
		save: (params: IFanSentimentsSavePayload) =>
			APIClient.post(`${getLang()}/draw-predictor/fan-sentiment/answer/save`, params),
	},
};

export default DrawPredictorApi;
